<script lang="ts">
  interface Props {
    count: number;
    label: string;
    loading?: boolean;
  }

  const { count, label, loading = false }: Props = $props();
</script>

{#if !loading}
  <span class="w-fit rounded-[6px] bg-alpha-025 px-2 py-px text-xs text-nowrap text-mono-800">
    {count}
    {label}
  </span>
{/if}
